import Common from '../../Common';
import Member from './queue/Member';

export interface UserQueue {
	id: id
	name: string | number
	maxlen: string | number
	strategy: string | number
	pbx_queue_number: string | number
	pbx_queue_type: string
	pbx_priority: string | number
	waiting: string | number
	completed: string | number
	total: string | number
	abandoned: string | number
	talktime: string | number
	holdtime: string | number
	member_total: string | number
	member_available: string | number
	wait_longest: string | number
	wait_avg: string | number
	service_level: string | number
	service_level_time: string | number
	wait_colors: {
		[key: string | number]: string
	},
	access: {
		pickup_call: string | number
		pause_members: string | number
		logout_members: string | number
		login_members: string | number
	},
}

const Queue = class extends Common {
	member: InstanceType<typeof Member>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.member = new Member(headers)
	}

	browse = (userId: id): CustomResponse<UserQueue[]> =>
		this.get(`/user/${userId}/queues`);
}

export default Queue
